import { getGetAPIMethod, getPostAPIMethod } from "@neum/frontend-shared/utils/api";

// PIMS Appointment APIs
export const getOnPremPimsAppointmentTypes = getGetAPIMethod(
  "/v1/getOnPremPimsAppointmentTypes"
);

export const importOnPremPimsAppointments = getPostAPIMethod(
  "/v1/importOnPremPimsAppointments"
);


// PIMS Transfer APIs
export const transferToOnPremPims = getPostAPIMethod(
  "/v1/transferToOnPremPims"
);


// PIMS Configuration APIs
export const setOnPremPimsStaffId = getPostAPIMethod(
  "/v1/setOnPremPimsStaffId"
);

export const createOnPremPimsInviteLink = getPostAPIMethod(
  "/v1/createOnPremPimsInviteLink"
);

export const getOnPremPimsInviteLink = getGetAPIMethod(
  "/v1/getOnPremPimsInviteLink"
);

export const pingOnPremPimsAccount = getPostAPIMethod(
  "/v1/pingOnPremPimsAccount"
); 